import {
  getReq,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
// import * as Utils from '@/utils'

// const

const state = {
  sysFrontendDDList: [],
  END_STATE: null
}

const getters = {}

const actions = {
  async findSysFrontendDDList({
    commit,
    state
  }, { codeParam }) {
    // debugger
    const responseData = await getReq(END_POINTS.FIND_SYS_FRONTEND_DD_LIST, { headerCodeMap: await getHeaderCodeMap(codeParam) })
    if (responseData.success) {
      commit('updateSysFrontendDDList', responseData.data)
    } else {
      commit('updateSysFrontendDDList', [])
    }
  }
}

const mutations = {
  updateSysFrontendDDList(state, list) {
    state.sysFrontendDDList = list
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/sysFrontendManage.js